import { render, staticRenderFns } from "./Marzipano.vue?vue&type=template&id=d52f8de0&scoped=true"
import script from "./Marzipano.vue?vue&type=script&lang=js"
export * from "./Marzipano.vue?vue&type=script&lang=js"
import style0 from "./Marzipano.vue?vue&type=style&index=0&id=d52f8de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52f8de0",
  null
  
)

export default component.exports